import React from "react";
import Pagination from "react-bootstrap/Pagination";

type Props = {
  totalPages: number;
  activePage: number;
  onPageChange: (pageNumber: number) => void;
};
const CustomPagination = ({ totalPages, activePage, onPageChange }: Props) => {
  const range = 2; // Number of visible pages on each side of the active page
  const items = [];

  // Add the first page
  items.push(
    <Pagination.First
      key="first-page"
      onClick={() => onPageChange(1)}
      disabled={activePage === 1}
    />
  );

  // Add the previous page
  items.push(
    <Pagination.Prev
      key="prev-page"
      onClick={() => onPageChange(activePage - 1)}
      disabled={activePage === 1}
    />
  );

  // Add the ellipsis if necessary (before the visible pages)
  if (activePage - range > 2) {
    items.push(<Pagination.Ellipsis key="ellipsis-prev" />);
  }

  // Add the visible pages
  for (
    let page: number = activePage - range;
    page <= activePage + range;
    page += 1
  ) {
    if (page > 0 && page <= totalPages) {
      items.push(
        <Pagination.Item
          key={page}
          active={page === activePage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Pagination.Item>
      );
    }
  }

  // Add the ellipsis if necessary (after the visible pages)
  if (activePage + range < totalPages - 1) {
    items.push(<Pagination.Ellipsis key="ellipsis-next" />);
  }

  // Add the next page
  items.push(
    <Pagination.Next
      key="next-page"
      onClick={() => onPageChange(activePage + 1)}
      disabled={activePage === totalPages}
    />
  );

  // Add the last page
  items.push(
    <Pagination.Last
      key="last-page"
      onClick={() => onPageChange(totalPages)}
      disabled={activePage === totalPages}
    />
  );

  return <Pagination size="lg">{items}</Pagination>;
};

export default CustomPagination;
